import { useTranslation } from "react-i18next"
import { formatDate, formatManualTime } from "helpers/FormatDateHelper"
import LabelGenerateDocuments from "overrides/theme/entelperu/base/components/Commons/LabelGenerateDocuments"
import translatesCanceledReasons from "overrides/theme/entelperu/base/translates/cancel_reasons.json"
import slotsHelper from "overrides/theme/entel/base/helpers/slots_helper"
import { useContext } from "react"
import { GlobalContext } from "context/context/GlobalContext"

const OrderInfoPrint = (props: any) => {
  const { schedules } = useContext(GlobalContext)
  const { t } = useTranslation()
  const { data } = props
  const _translatesCanceledReasons = translatesCanceledReasons as any

  const currentStatus = data?._sg?._omnixStateMachine?.currentState?.state?.name

  // const enviameLabel = data?._sg?.enviameLabel ? data?._sg?.enviameLabel[0] : null
  // const enviameDocsProperty =
  //   enviameLabel && Object.values(enviameLabel).some((doc: any) => Boolean(doc)) ? true : false

  const isGeneratingDTE = !data?._sg?.deliveryChargeDocumentData?.fileName ? true : false
  // const isGeneratingEnviameDocs = !enviameDocsProperty ? true : false

  const _slotDelivery = slotsHelper(schedules?.state, data?._sg)

  const get_mark_on_delivered_closed_orders = () => {
    const isDelivered = currentStatus?.toLocaleUpperCase() === "DELIVERED"
    const hasClosedOrderKey = data?._sg?.custom?.hasOwnProperty("closedOrder")
    const notProgramado = data?._sg?.deliveryType !== "PROGRAMADO"
    if (isDelivered && hasClosedOrderKey && notProgramado) {
      return data?._sg?.custom?.closedOrder ? "Si" : "No"
    }
    return false
  }

  const isClosedOrder = get_mark_on_delivered_closed_orders() === "Si" ? "#008f39" : "#ff2c2c"

  const isCanceledOrder = Boolean(currentStatus?.toLocaleUpperCase() === "CANCELED")

  const reason_cancel = data?._sg?._omnixStateMachine?.currentState?.state?.custom?.reason

  const template = (
    <section className="order__main__detail">
      <h2>{t("Guía de despacho")}</h2>
      <article className="order__main__detail__summary">
        <h3>Información General</h3>
        <div>
          <p>{t("Fecha de estado actual")}:</p>
          <p>
            <strong>{formatDate(data?._sg?._omnixStateMachine?.currentState?.date)}</strong>
          </p>
        </div>
        {data?._sg?.isRescheduledOrder ? (
          <div>
            <p style={{ color: "#e5be01" }}>{t("Orden reagendada")}</p>
            <p></p>
          </div>
        ) : null}
        {data?._sg?.isRescheduledOrder ? (
          <div>
            <p>{t("Fecha original de entrega")}:</p>
            <p>{`${formatDate(data?._sg?.originalEstimatedDeliveryDate)} ${formatManualTime(data?._sg?.originalEstimatedDeliveryDate)}`}</p>
          </div>
        ) : null}
        {data?._order?.courier?.enviame?.data?.carrier ? (
          <div>
            <p>{t("Transportista")}:</p>
            <p>
              <strong>{data?._order?.courier?.enviame?.data?.carrier}</strong>
            </p>
          </div>
        ) : null}
        {data?._sg?.orderType ? (
          <div>
            <p>{t("Tipo de orden")}:</p>
            <p>
              <strong>{data?._sg?.orderType}</strong>
            </p>
          </div>
        ) : null}
        {data?._order?.deliveryType && (
          <div>
            <p>{t("Tipo de entrega")}:</p>
            <p>
              <strong>
                {t(
                  `${data?._order?.slotDelivery?.slotType} / ${formatManualTime(
                    _slotDelivery.initial,
                  )} - ${formatManualTime(_slotDelivery?.final)}`,
                )}
              </strong>
            </p>
          </div>
        )}
        <div>
          <p>{t("DTE Folio")}:</p>
          <LabelGenerateDocuments show_loader={Boolean(isGeneratingDTE)} currentStatus={currentStatus}>
            {data?._sg?.deliveryChargeDocumentData?.url?.includes("http") ? (
              <a href={data?._sg?.deliveryChargeDocumentData?.url} target="_blank" rel="noreferrer">
                <strong className="order__main__detail__folio__url">
                  {data?._sg?.deliveryChargeDocumentData?.fileName}
                </strong>
              </a>
            ) : data?._sg?.dte?.url?.includes("false") ? (
              <p>N/A</p>
            ) : (
              <p>No se generó el documento</p>
            )}
          </LabelGenerateDocuments>
        </div>
        {/* {courierName && courierName !== "BRIGHTCELL" ? (
          <>
            <div>
              <p>{t("Enviame Documentos")}:</p>
              <div>
                <LabelGenerateDocuments show_loader={Boolean(isGeneratingEnviameDocs)} currentStatus={currentStatus}>
                  {enviameLabel &&
                  Object.values(enviameLabel).some((doc: any) => Boolean(doc?.toString()?.includes("http"))) ? (
                    <div>
                      <p>
                        <a href={enviameLabel?.labels} target="_blank" rel="noreferrer">
                          <strong className="order__main__detail__folio__url">Etiqueta</strong>
                        </a>
                      </p>
                      <p>
                        <a href={enviameLabel?.summary} target="_blank" rel="noreferrer">
                          <strong className="order__main__detail__folio__url">Manifiesto</strong>
                        </a>
                      </p>
                    </div>
                  ) : enviameLabel &&
                    Object.values(enviameLabel).some((doc: any) => Boolean(doc?.toString()?.includes("false"))) ? (
                    <p>N/A</p>
                  ) : (
                    <p>No se generó el documento</p>
                  )}
                </LabelGenerateDocuments>
              </div>
            </div>
          </>
        ) : null} */}
        {get_mark_on_delivered_closed_orders() ? (
          <div>
            <p style={{ color: isClosedOrder }}>{t("Orden cerrada en caja si/no")}:</p>
            <p style={{ color: isClosedOrder }}>
              <strong>{get_mark_on_delivered_closed_orders()}</strong>
            </p>
          </div>
        ) : null}
        {isCanceledOrder ? (
          <div>
            <p style={{ color: "#ff2c2c" }}>{t("Motivo de cancelación")}:</p>
            <p style={{ color: "#ff2c2c" }}>
              <strong>{_translatesCanceledReasons[reason_cancel] || reason_cancel}</strong>
            </p>
          </div>
        ) : null}
      </article>
    </section>
  )

  return template
}

export default OrderInfoPrint
